import { render, staticRenderFns } from "./trifuerza.vue?vue&type=template&id=bd5a6850&scoped=true"
var script = {}
import style0 from "./trifuerza.vue?vue&type=style&index=0&id=bd5a6850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5a6850",
  null
  
)

export default component.exports